import React from "react";

const LaptopService = () => {
  return <div>Ls</div>;
};

export default LaptopService;
